<template>
  <Section id="platform-trio" tone="muted" pad-y="lg" aria-labelledby="platform-heading">
    <Container>
      <div class="mb-10 flex flex-col gap-3">
        <h2 id="platform-heading" class="text-3xl font-bold text-ink-strong md:text-4xl">
          {{ t('sections.platform.title') }}
        </h2>
        <p class="max-w-2xl text-base text-ink-muted md:text-lg">
          {{ t('sections.platform.subtitle') }}
        </p>
      </div>
      <Grid :cols="{ base: 1, md: 2, lg: 4 }" :gap="6">
        <PlatformCard
          v-for="item in PLATFORM_TRIO"
          :key="item.id"
          :icon-name="item.iconName as IconName"
          :title="pickLocalized(item, 'title', locale)"
          :description="pickLocalized(item, 'description', locale)"
          :anchor="item.anchor"
          :cta-label="t('cta.details')"
        />
      </Grid>
    </Container>
  </Section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import Section from '@/components/primitives/Section.vue';
import Container from '@/components/primitives/Container.vue';
import Grid from '@/components/primitives/Grid.vue';
import PlatformCard from '@/components/domain/PlatformCard.vue';
import { PLATFORM_TRIO } from '@/content/home-data';
import { useLocale } from '@/composables/useLocale';
import { pickLocalized } from '@/lib/i18n/localize';
import type { IconName } from '@/components/base/icons';

const { t } = useI18n();
const { locale } = useLocale();
</script>
